// ─────────────────────────────────────────────
//  Firebase Configuration
// ─────────────────────────────────────────────
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey:            "AIzaSyAvKdGlCFCeDy7HoNgVaHdwZLbYZgafKn4",
  authDomain:        "the-patch-guys.firebaseapp.com",
  projectId:         "the-patch-guys",
  storageBucket:     "the-patch-guys.firebasestorage.app",
  messagingSenderId: "1076489025531",
  appId:             "1:1076489025531:web:54fd1b5ec7f5f894403d5e",
};

const app      = initializeApp(firebaseConfig);
export const db       = getFirestore(app);
export const auth     = getAuth(app);
export const storage  = getStorage(app);
export const googleProvider = new GoogleAuthProvider();